import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ErrorStore, UnreadHorseNotification } from '@sleipai/sleip-models';

import {
  selectAllUnreadNotificationCountsByHorseAdapter,
  selectUnreadNotificationCountsByHorseEntitiesAdapter,
  UnreadNotificationCountsByHorseState,
} from '../entity/unread-notification-counts-by-horse.entity';
import { State } from '../reducers/notification.reducer';
import { selectNotificationsState } from './notification.selectors';

export const unreadNotificationCountsByHorseSlice = (
  state: State
): UnreadNotificationCountsByHorseState => state.unreadNotificationCountsByHorse;
export const isUnreadNotificationCountsLoading = (state: State): boolean => state.unreadNotificationCountsLoading;
export const isUnreadNotificationCountsLoaded = (state: State): boolean => state.unreadNotificationCountsLoaded;
export const unreadNotificationCountsError = (state: State): ErrorStore | null =>
  state.unreadNotificationCountsError;

const selectUnreadNotificationCountsByHorseSlice = createSelector(
  selectNotificationsState,
  unreadNotificationCountsByHorseSlice
);

export const selectUnreadHorseNotificationEntities = createSelector(
  selectUnreadNotificationCountsByHorseSlice,
  selectUnreadNotificationCountsByHorseEntitiesAdapter
);

export const selectAllUnreadNotificationCountsByHorse: MemoizedSelector<
  object,
  UnreadHorseNotification[]
> = createSelector(selectUnreadNotificationCountsByHorseSlice, selectAllUnreadNotificationCountsByHorseAdapter);

export const selectIsUnreadNotificationCountsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectNotificationsState, isUnreadNotificationCountsLoading);

export const selectIsUnreadNotificationCountsLoaded: MemoizedSelector<object, boolean> =
  createSelector(selectNotificationsState, isUnreadNotificationCountsLoaded);

export const selectUnreadNotificationCountsError: MemoizedSelector<object, ErrorStore | null> =
  createSelector(selectNotificationsState, unreadNotificationCountsError);

export const selectUnreadNotificationCountsByHorse: MemoizedSelector<
  object,
  Record<string, number>
> = createSelector(selectAllUnreadNotificationCountsByHorse, (unreadHorses) =>
  unreadHorses.reduce((counts, unreadHorse) => {
    counts[unreadHorse.horseId] = unreadHorse.unreadCount ?? 0;
    return counts;
  }, {} as Record<string, number>)
);

export const selectTotalUnreadNotificationCount: MemoizedSelector<object, number> =
  createSelector(selectAllUnreadNotificationCountsByHorse, (unreadHorses) =>
    unreadHorses.reduce(
      (total, unreadHorse) => total + (unreadHorse.unreadCount ?? 0),
      0
    )
  );

